export default class TeamsTransformation {
  static transformTeam(data) {
    const { id, title } = data;
    return { title, id };
  }

  static transformListOfTeams(listOfTeams = []) {
    return listOfTeams
      .map((team) => this.transformTeam(team))
      .filter((team) => !['نامشخص' || 'unknown'].includes(team.title?.toLowerCase()));
  }
}
